<template>
    <div class="similar-image-review-decision-panel">
        <el-radio-group class="similar-image-review-decision-panel__group" :value="value" size="mini" @input="$emit('input', $event)">
            <el-radio-button label="pending">待定</el-radio-button>
            <el-radio-button label="confirmed-valid">确认有效</el-radio-button>
            <el-radio-button label="confirmed-rejected">确认排除</el-radio-button>
        </el-radio-group>
        <el-button
            class="similar-image-review-decision-panel__save"
            size="mini"
            type="primary"
            :loading="saving"
            @click="$emit('save')"
        >
            保存判断
        </el-button>
    </div>
</template>

<script>
export default {
    name: "SimilarImageReviewDecisionPanel",
    props: {
        value: {
            type: String,
            default: "pending",
        },
        saving: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.similar-image-review-decision-panel {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.similar-image-review-decision-panel__group,
.similar-image-review-decision-panel__save {
    width: 100%;
}
</style>
